module.exports = __webpack_public_path__ + "img/25012379a963dd85da2e7a42e6a697ebe0db317f.7d500eac.png";